/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The HTTP method to use for the callback. Allowed values are 'POST' or 'PUT'.
 */
export type RetryCallbackRequestBodyInputAnyOfMethod =
  (typeof RetryCallbackRequestBodyInputAnyOfMethod)[keyof typeof RetryCallbackRequestBodyInputAnyOfMethod]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RetryCallbackRequestBodyInputAnyOfMethod = {
  POST: "POST",
  PUT: "PUT"
} as const
